// extracted by mini-css-extract-plugin
export default {"root":"SelectEntity_root__j39hO","text":"SelectEntity_text__6EoiM"};